"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Button = _interopRequireDefault(require("@cimpress/react-components/lib/Button"));

var _Modal = _interopRequireDefault(require("@cimpress/react-components/lib/Modal"));

var _TextField = _interopRequireDefault(require("@cimpress/react-components/lib/TextField"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var shapes = _interopRequireWildcard(require("../shapes"));

var sheetUtils = _interopRequireWildcard(require("../utils/sheetUtils"));

var _Dropzone = _interopRequireDefault(require("../Dropzone"));

var _FileModalButtons = _interopRequireDefault(require("./FileModalButtons"));

var _FileModalError = _interopRequireDefault(require("./FileModalError"));

var defaultState = {
  columns: null,
  error: null,
  file: null,
  rows: null
};

var FileModal =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FileModal, _PureComponent);

  function FileModal() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, FileModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(FileModal)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dropzoneRef", (0, _react.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", defaultState);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDrop",
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(files) {
        var _this$props, additionalColumns, maxFileSize, optionalColumns, requiredColumns, file, _ref2, columns, error, rows;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, additionalColumns = _this$props.additionalColumns, maxFileSize = _this$props.maxFileSize, optionalColumns = _this$props.optionalColumns, requiredColumns = _this$props.requiredColumns;
                file = files[0];
                _context.next = 4;
                return sheetUtils.loadFile(file, {
                  additionalColumns: additionalColumns,
                  maxFileSize: maxFileSize,
                  optionalColumns: optionalColumns,
                  requiredColumns: requiredColumns
                });

              case 4:
                _ref2 = _context.sent;
                columns = _ref2.columns;
                error = _ref2.error;
                rows = _ref2.rows;

                _this.setState({
                  columns: columns,
                  error: error,
                  file: file,
                  rows: rows
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onOpenPrompt", function () {
      if (_this.dropzoneRef.current) {
        _this.dropzoneRef.current.open();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSubmit", function () {
      var onSubmit = _this.props.onSubmit;
      var _this$state = _this.state,
          rows = _this$state.rows,
          columns = _this$state.columns,
          file = _this$state.file;
      onSubmit && onSubmit(columns, rows, file);
    });
    return _this;
  }

  (0, _createClass2.default)(FileModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // If the modal closed, clear out the current state.
      if (prevProps.show && !this.props.show) {
        this.setState(defaultState);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          show = _this$props2.show,
          title = _this$props2.title,
          onCancel = _this$props2.onCancel;
      var _this$state2 = this.state,
          columns = _this$state2.columns,
          error = _this$state2.error,
          rows = _this$state2.rows,
          file = _this$state2.file;
      var filename = file ? file.name : '';
      var canSubmit = !error && !!columns && !!rows;

      var footer = _react.default.createElement(_FileModalButtons.default, {
        canSubmit: canSubmit,
        onCancel: onCancel,
        onSubmit: this.onSubmit
      });

      var uploadButton = _react.default.createElement(_Button.default, {
        type: "primary",
        onClick: this.onOpenPrompt
      }, "Choose File");

      return _react.default.createElement(_Modal.default, {
        closeButton: true,
        closeOnOutsideClick: true,
        footer: footer,
        show: show,
        title: title,
        onRequestHide: onCancel
      }, _react.default.createElement(_TextField.default, {
        label: "Filename",
        readOnly: true,
        rightAddon: uploadButton,
        value: filename
      }), _react.default.createElement(_Dropzone.default, {
        ref: this.dropzoneRef,
        onDrop: this.onDrop
      }), _react.default.createElement(_FileModalError.default, {
        value: error
      }));
    }
  }]);
  return FileModal;
}(_react.PureComponent);

exports.default = FileModal;
(0, _defineProperty2.default)(FileModal, "propTypes", {
  additionalColumns: _propTypes.default.oneOf(['allow', 'disallow', 'ignore']),
  maxFileSize: _propTypes.default.number,
  optionalColumns: shapes.columnList,
  requiredColumns: shapes.columnList,
  show: _propTypes.default.bool,
  title: _propTypes.default.string,
  onCancel: _propTypes.default.func,
  onSubmit: _propTypes.default.func
});
(0, _defineProperty2.default)(FileModal, "defaultProps", {
  additionalColumns: 'allow',
  optionalColumns: [],
  requiredColumns: [],
  title: 'Upload a File'
});